import {
  GET_DATA_RETENTION_POLICIES,
  GET_DATA_RETENTION_POLICIES_SUCCESS,
  GET_DATA_RETENTION_POLICIES_ERROR,
} from './actionTypes';

const initialState = {
  errorGetDataRetentionPolicies: '',
  loadingGetDataRetentionPolicies: false,
  dataRetentionPolicies: null,
};

const getDataRetentionPolicies = (state = initialState, action) => {
  switch (action.type) {
    case GET_DATA_RETENTION_POLICIES:
      state = { ...state, loadingGetDataRetentionPolicies: true };
      break;
    case GET_DATA_RETENTION_POLICIES_SUCCESS:
      state = {
        ...state,
        loadingGetDataRetentionPolicies: false,
        dataRetentionPolicies: action.payload.policies,
      };
      break;
    case GET_DATA_RETENTION_POLICIES_ERROR:
      state = { ...state, errorGetDataRetentionPolicies: action.payload, loadingGetDataRetentionPolicies: false };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default getDataRetentionPolicies;
